// extracted by mini-css-extract-plugin
export default {"maxWidthInPc":"450px","footerContainer":"style_footerContainer__PZOcm","error":"style_error__ts8+H","title":"style_title__KI535","errorMessage":"style_errorMessage__F420r"};